// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAATCAYAAAB/TkaLAAAEZElEQVQ4jXWUCWxUVRSG/3vfmzcLM12gDZ0RKUNiNAQbjVXikghJkYSYKIWgIotaEloVMZLYSCXKkhiNxSiQikhYWg0iS9oqlIJABFkLaUu1xJbSTjtbO1tnOst7b+Zdc1+gQtqe5EvuknNyzrn/PSTu92IiYwCowQA1EjJE/2ndMnVB6UZQqrJ0egKPu6Zk0hOjqmCMwXf+dNnRbLDBy+ff4XtFUaGk0xNCM7EoJoIpMjQw9P+8ZytPu2//zq08e0IJWFoFz3g8xHhv15jseQAGBrPjYbgbfvkkcK65IGuWE0NnTtgHGg5V2heWfpnyDIAQMsaVGxWtWRgP45SpYJmM1XPowGYiGpD9xJyYIJngqq3ZLIcDVmoy6z0fDyT83rEM+qAxhq5d22p4L6+WlXo1xpxXVy/xHLGBde3+ZofeWzkFJT4yBsiJ+IPER/SAiYB/1pm5s1njQxJzN9Wv5UHcTfXrGuwiOzt3NkvFoo/xs/Q40JTPjQcI+KGlVbjqftgWutSBGWUVf1KzWb2w5KU2wWxRZ5S9ez5wsQN39m7/jpcqBwNIDfoegApGE0aRjJDMkxBsuVjSu7dmgfXRAuSXvLx2uK0lN3L1clG0sz3LsXRVhe2RfLj27JwfamuZZzAYIBACgdJR9FI5GcZ0TXJaq96/eUgA69hSeYVr0t3c+Nzt2poq7x8nnuXl3dy0/tqvAljrhvfa2X1+90C077bOcG+33njvmROrfp9pY6eecbKYp7841N2JGx+v2XeyqCB8/cO394343EiEAsXNxdNZY6GZ+S+dW8YDJSKhUag4yQrRYoVxch4IFUTXge+3J90xOCvWN1rt01ri3bcATctWhyM5RKDZkY5WmHOntDjL1zemfEn0/vjtjgxjomiygAoCKBVABYsNoi0HRls23IdrN3mP19vyXnwSzuVrPlAiIWTiCQiSSRYsFhDJJGtyCmAMzpXl6/LnPQVv/bHcgSM/fW4wGnV9C5ZJoNRogsEoQZVlh6tu1wamANNXlH9NRbE32n0LSiwCIhkAQkANEpRwEOGOVggG6U7h8jXVmqp/36p0WrUL/DfxbGW/B0zL6BIaOnsFjtJX49OWlW2MD/rANAZjzmTIg97cRE8Q8pB/smC1Qo2PYMTrhmPxik8di15JDJ2+jL7aXdX8M/E7JMMBhDvb5jQXF7KmInsm2H59PldD+Pa/GPF7ER1wYaCp/rW/v6g67j7ZsDTa34e4z4twT5eumEDbtZKmxwu0U08XsmHXnWIlmQThL9extfJCz46vnncsfiNpX/Rmtez3SIJkNDFNY0SUqDQlLyzaskzpWDSlBIdyWVrVCBWIpshJ41S74jlaV+k5dlCaWf7RX7M/q36B9P92ePWNsiW7zXYHCO9ZJPj/lOBjjvDHz+h7viZUuHd11wiknFx9FCbdHhQfPP6WGO/qfD2/ZOGwZbozzFSZsIxGQMhdv3vuPBofc1zcoyf3xSWgksSS/X050faWlf8Ba1jnhwXMkasAAAAASUVORK5CYII=", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body,
#root {
  height: 100%;
  margin: 0;
  padding: 0;
  overflow-x: hidden;
}

#root {
  display: flex;
  flex-direction: column;
}


/*add alert icon before error message*/
.gtCzxm:before{
 float:left;
  height: 17px; 
  width: 17px;
  padding-right: 12px;  
  margin-top:2px;
  color:#A00E18 !important;
  content: " ";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center bottom !important;
}


/*only display icon when there is text in the error message */
.gtCzxm:empty:before{
    display:none;
}


/*override text styles for error block within TextInput mux component*/
.gtCzxm{
  position: relative;
  overflow:visible;
  white-space:nowrap;
  width: 250px;
  height: 18px;
  left: 0px;
  top: 0px;
  font-family: Manulife JH Sans;
  font-style: normal;
  font-weight: 500;
  font-size: 13px;
  line-height: 18px;
  color: #A00E18 !important;
}

/*change the background of input only when aria-describedby attribute contains the substring -error.  this means the error is being displayed*/
input[type = "text"][ aria-describedby*="-errors"]{
  background: #F6DCD8 !important;
  mix-blend-mode: normal;
  opacity: 0.4;
  border-color: #DB1F00 !important;
}

input:focus-visible {
  outline: 0px;
}

/*apply styling to placeholder text - can't be done directly within textinput */
.hmvpsk {
    font-weight: normal !important;
    font-family: Manulife JH Sans !important;
    font-size: 16px !important;
    color: #8E90A2 !important;
    margin-left: -12px !important;
}

/* Message card css */
.cyqRAS {
  border: none !important;
  box-shadow: 1px 1px 12px -2px #969696 !important;
}

.cUPqZU {
  width: 8px !important;
  background-color: #A00E18 !important;
}

.dzOfZF {
  color: #282B3E !important;
}

.XIJXq {
  color: #282B3E !important;
}

/* Change the radio button hover property */
.hCYxMF:hover {
  border: 2px solid #0000C1;
}

.ftDTSe{
    position:relative;
    margin-top:-100px !important;
}

.kUYRBv{
  border: 1px solid #8E90A2 !important;
}

.iTpAxK{
  font-weight:500;
  font-size: 16px;
  font-family: Manulife JH Sans;

}

#wolChecked{
    position: relative;
}

#lastSixDigitSSN-errors {
    left: -39px !important;
    display: none;
}

#authPassword-errors {
  left: -39px !important;
  display: none;
}

#password-errors {
  left: -39px !important;
  display: none;
}

#confirmPassword-errors {
  left: -39px !important;
  display: none;
}

#year-value {
    font-weight: normal !important;
    color: #8E90A2 !important;
}

#month-value {
    font-weight: normal !important;
    color: #8E90A2 !important;
}

#day-value {
    font-weight: normal !important;
    color: #8E90A2 !important;
}

td {
  padding-bottom: 20px;
}

/* override eye icon size */
.nZLjj svg, .nZLjj span {
  width: 20px !important;
  height: 20px !important;
}

/* Style changed in confirmation modal page */
#last6DigitSSN:disabled {
  color: #000000 !important;
  background-color: white;
  padding-left: 0px;
  font-size: 16px;
  line-height: 26px;
  font-family: Manulife JH Sans, Helvetica, Arial, sans-serif;
  font-weight: 500;
}
.hyxeSj {
  border-width: 0px 0px 0px 0px !important;
}



.app-container{
  width: 100%;
  display: flex;
  flex-direction: row;
  height: 100%;
}

.left-navigation-panel{
  width: 80px;
  background-color: #34384B;
  height: 100%;
  position: sticky;
  top: 0;
  left: 0;
}

@media only screen and (max-width: 600px) {
  .left-navigation-panel{
    display: none;
  }
}
.body-container{
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow-y: scroll;
  overflow-x: hidden;
}
.home-menu-item{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #34384B;
  padding: 20px 28px;
  cursor: pointer;
  text-decoration: none;
}
.home-menu-item:hover {  
  background-color: #282B3E;
}
.menu-item-text{
  font-size: 13px;
  line-height: 13px;
  font-weight: 400;
  color: #ffffff;
  margin-top: 5px;
}
.app-content {
  flex: 1 0 auto;
}

.gridSeparation {
  margin-bottom: 40px !important;
}

/* Override TextInput Error border color */
.myinput.error div div div{
  border-color: #A00E18 !important;
  margin-top: 0 !important;
}
.myinput.error div div div:hover{
  border-color: #A00E18 !important;
}
.myinput.error div div div::after{
  border-color: #A00E18 !important;
}
.myinput.error div div div::before{
  border-color: #A00E18 !important;
}

.myinput.error div div button{
  border-color: #A00E18 !important;
}
.myinput.error div div button:hover{
  border-color: #A00E18 !important;
}
.myinput.error div div button::after{
  border-color: #A00E18 !important;
}
.myinput.error div div button::before{
  border-color: #A00E18 !important;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;;;EAGE,YAAY;EACZ,SAAS;EACT,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;;AAGA,sCAAsC;AACtC;CACC,UAAU;EACT,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,cAAc;EACd,wBAAwB;EACxB,YAAY;EACZ,sFAAknD;AACpnD;;;AAGA,6DAA6D;AAC7D;IACI,YAAY;AAChB;;;AAGA,sEAAsE;AACtE;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,SAAS;EACT,QAAQ;EACR,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA,8IAA8I;AAC9I;EACE,8BAA8B;EAC9B,sBAAsB;EACtB,YAAY;EACZ,gCAAgC;AAClC;;AAEA;EACE,YAAY;AACd;;AAEA,+EAA+E;AAC/E;IACI,8BAA8B;IAC9B,wCAAwC;IACxC,0BAA0B;IAC1B,yBAAyB;IACzB,6BAA6B;AACjC;;AAEA,qBAAqB;AACrB;EACE,uBAAuB;EACvB,gDAAgD;AAClD;;AAEA;EACE,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,2CAA2C;AAC3C;EACE,yBAAyB;AAC3B;;AAEA;IACI,iBAAiB;IACjB,4BAA4B;AAChC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,eAAe;EACf,6BAA6B;;AAE/B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,aAAa;AACjB;;AAEA;EACE,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,aAAa;AACf;;AAEA;IACI,8BAA8B;IAC9B,yBAAyB;AAC7B;;AAEA;IACI,8BAA8B;IAC9B,yBAAyB;AAC7B;;AAEA;IACI,8BAA8B;IAC9B,yBAAyB;AAC7B;;AAEA;EACE,oBAAoB;AACtB;;AAEA,2BAA2B;AAC3B;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA,6CAA6C;AAC7C;EACE,yBAAyB;EACzB,uBAAuB;EACvB,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,2DAA2D;EAC3D,gBAAgB;AAClB;AACA;EACE,wCAAwC;AAC1C;;;;AAIA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB,MAAM;EACN,OAAO;AACT;;AAEA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,qBAAqB;AACvB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,8BAA8B;AAChC;;AAEA,0CAA0C;AAC1C;EACE,gCAAgC;EAChC,wBAAwB;AAC1B;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC","sourcesContent":["html,\nbody,\n#root {\n  height: 100%;\n  margin: 0;\n  padding: 0;\n  overflow-x: hidden;\n}\n\n#root {\n  display: flex;\n  flex-direction: column;\n}\n\n\n/*add alert icon before error message*/\n.gtCzxm:before{\n float:left;\n  height: 17px; \n  width: 17px;\n  padding-right: 12px;  \n  margin-top:2px;\n  color:#A00E18 !important;\n  content: \" \";\n  background: url(\"data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAATCAYAAAB/TkaLAAAEZElEQVQ4jXWUCWxUVRSG/3vfmzcLM12gDZ0RKUNiNAQbjVXikghJkYSYKIWgIotaEloVMZLYSCXKkhiNxSiQikhYWg0iS9oqlIJABFkLaUu1xJbSTjtbO1tnOst7b+Zdc1+gQtqe5EvuknNyzrn/PSTu92IiYwCowQA1EjJE/2ndMnVB6UZQqrJ0egKPu6Zk0hOjqmCMwXf+dNnRbLDBy+ff4XtFUaGk0xNCM7EoJoIpMjQw9P+8ZytPu2//zq08e0IJWFoFz3g8xHhv15jseQAGBrPjYbgbfvkkcK65IGuWE0NnTtgHGg5V2heWfpnyDIAQMsaVGxWtWRgP45SpYJmM1XPowGYiGpD9xJyYIJngqq3ZLIcDVmoy6z0fDyT83rEM+qAxhq5d22p4L6+WlXo1xpxXVy/xHLGBde3+ZofeWzkFJT4yBsiJ+IPER/SAiYB/1pm5s1njQxJzN9Wv5UHcTfXrGuwiOzt3NkvFoo/xs/Q40JTPjQcI+KGlVbjqftgWutSBGWUVf1KzWb2w5KU2wWxRZ5S9ez5wsQN39m7/jpcqBwNIDfoegApGE0aRjJDMkxBsuVjSu7dmgfXRAuSXvLx2uK0lN3L1clG0sz3LsXRVhe2RfLj27JwfamuZZzAYIBACgdJR9FI5GcZ0TXJaq96/eUgA69hSeYVr0t3c+Nzt2poq7x8nnuXl3dy0/tqvAljrhvfa2X1+90C077bOcG+33njvmROrfp9pY6eecbKYp7841N2JGx+v2XeyqCB8/cO394343EiEAsXNxdNZY6GZ+S+dW8YDJSKhUag4yQrRYoVxch4IFUTXge+3J90xOCvWN1rt01ri3bcATctWhyM5RKDZkY5WmHOntDjL1zemfEn0/vjtjgxjomiygAoCKBVABYsNoi0HRls23IdrN3mP19vyXnwSzuVrPlAiIWTiCQiSSRYsFhDJJGtyCmAMzpXl6/LnPQVv/bHcgSM/fW4wGnV9C5ZJoNRogsEoQZVlh6tu1wamANNXlH9NRbE32n0LSiwCIhkAQkANEpRwEOGOVggG6U7h8jXVmqp/36p0WrUL/DfxbGW/B0zL6BIaOnsFjtJX49OWlW2MD/rANAZjzmTIg97cRE8Q8pB/smC1Qo2PYMTrhmPxik8di15JDJ2+jL7aXdX8M/E7JMMBhDvb5jQXF7KmInsm2H59PldD+Pa/GPF7ER1wYaCp/rW/v6g67j7ZsDTa34e4z4twT5eumEDbtZKmxwu0U08XsmHXnWIlmQThL9extfJCz46vnncsfiNpX/Rmtez3SIJkNDFNY0SUqDQlLyzaskzpWDSlBIdyWVrVCBWIpshJ41S74jlaV+k5dlCaWf7RX7M/q36B9P92ePWNsiW7zXYHCO9ZJPj/lOBjjvDHz+h7viZUuHd11wiknFx9FCbdHhQfPP6WGO/qfD2/ZOGwZbozzFSZsIxGQMhdv3vuPBofc1zcoyf3xSWgksSS/X050faWlf8Ba1jnhwXMkasAAAAASUVORK5CYII=\") no-repeat center bottom !important;\n}\n\n\n/*only display icon when there is text in the error message */\n.gtCzxm:empty:before{\n    display:none;\n}\n\n\n/*override text styles for error block within TextInput mux component*/\n.gtCzxm{\n  position: relative;\n  overflow:visible;\n  white-space:nowrap;\n  width: 250px;\n  height: 18px;\n  left: 0px;\n  top: 0px;\n  font-family: Manulife JH Sans;\n  font-style: normal;\n  font-weight: 500;\n  font-size: 13px;\n  line-height: 18px;\n  color: #A00E18 !important;\n}\n\n/*change the background of input only when aria-describedby attribute contains the substring -error.  this means the error is being displayed*/\ninput[type = \"text\"][ aria-describedby*=\"-errors\"]{\n  background: #F6DCD8 !important;\n  mix-blend-mode: normal;\n  opacity: 0.4;\n  border-color: #DB1F00 !important;\n}\n\ninput:focus-visible {\n  outline: 0px;\n}\n\n/*apply styling to placeholder text - can't be done directly within textinput */\n.hmvpsk {\n    font-weight: normal !important;\n    font-family: Manulife JH Sans !important;\n    font-size: 16px !important;\n    color: #8E90A2 !important;\n    margin-left: -12px !important;\n}\n\n/* Message card css */\n.cyqRAS {\n  border: none !important;\n  box-shadow: 1px 1px 12px -2px #969696 !important;\n}\n\n.cUPqZU {\n  width: 8px !important;\n  background-color: #A00E18 !important;\n}\n\n.dzOfZF {\n  color: #282B3E !important;\n}\n\n.XIJXq {\n  color: #282B3E !important;\n}\n\n/* Change the radio button hover property */\n.hCYxMF:hover {\n  border: 2px solid #0000C1;\n}\n\n.ftDTSe{\n    position:relative;\n    margin-top:-100px !important;\n}\n\n.kUYRBv{\n  border: 1px solid #8E90A2 !important;\n}\n\n.iTpAxK{\n  font-weight:500;\n  font-size: 16px;\n  font-family: Manulife JH Sans;\n\n}\n\n#wolChecked{\n    position: relative;\n}\n\n#lastSixDigitSSN-errors {\n    left: -39px !important;\n    display: none;\n}\n\n#authPassword-errors {\n  left: -39px !important;\n  display: none;\n}\n\n#password-errors {\n  left: -39px !important;\n  display: none;\n}\n\n#confirmPassword-errors {\n  left: -39px !important;\n  display: none;\n}\n\n#year-value {\n    font-weight: normal !important;\n    color: #8E90A2 !important;\n}\n\n#month-value {\n    font-weight: normal !important;\n    color: #8E90A2 !important;\n}\n\n#day-value {\n    font-weight: normal !important;\n    color: #8E90A2 !important;\n}\n\ntd {\n  padding-bottom: 20px;\n}\n\n/* override eye icon size */\n.nZLjj svg, .nZLjj span {\n  width: 20px !important;\n  height: 20px !important;\n}\n\n/* Style changed in confirmation modal page */\n#last6DigitSSN:disabled {\n  color: #000000 !important;\n  background-color: white;\n  padding-left: 0px;\n  font-size: 16px;\n  line-height: 26px;\n  font-family: Manulife JH Sans, Helvetica, Arial, sans-serif;\n  font-weight: 500;\n}\n.hyxeSj {\n  border-width: 0px 0px 0px 0px !important;\n}\n\n\n\n.app-container{\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  height: 100%;\n}\n\n.left-navigation-panel{\n  width: 80px;\n  background-color: #34384B;\n  height: 100%;\n  position: sticky;\n  top: 0;\n  left: 0;\n}\n\n@media only screen and (max-width: 600px) {\n  .left-navigation-panel{\n    display: none;\n  }\n}\n.body-container{\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  overflow-y: scroll;\n  overflow-x: hidden;\n}\n.home-menu-item{\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  background-color: #34384B;\n  padding: 20px 28px;\n  cursor: pointer;\n  text-decoration: none;\n}\n.home-menu-item:hover {  \n  background-color: #282B3E;\n}\n.menu-item-text{\n  font-size: 13px;\n  line-height: 13px;\n  font-weight: 400;\n  color: #ffffff;\n  margin-top: 5px;\n}\n.app-content {\n  flex: 1 0 auto;\n}\n\n.gridSeparation {\n  margin-bottom: 40px !important;\n}\n\n/* Override TextInput Error border color */\n.myinput.error div div div{\n  border-color: #A00E18 !important;\n  margin-top: 0 !important;\n}\n.myinput.error div div div:hover{\n  border-color: #A00E18 !important;\n}\n.myinput.error div div div::after{\n  border-color: #A00E18 !important;\n}\n.myinput.error div div div::before{\n  border-color: #A00E18 !important;\n}\n\n.myinput.error div div button{\n  border-color: #A00E18 !important;\n}\n.myinput.error div div button:hover{\n  border-color: #A00E18 !important;\n}\n.myinput.error div div button::after{\n  border-color: #A00E18 !important;\n}\n.myinput.error div div button::before{\n  border-color: #A00E18 !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
